<template>
  <a-form layout="vertical" :model="formState" ref="formRef">
    <DisabledContainer :isDisabled="disabled">
      <a-form-item
        label="Archivo de audio"
        name="file_audio"
        class="audio-form-item-mb0"
        :rules="[{ required: true, message: 'Por favor ingresar archivo de audio' }]"
        :validateStatus="validateAudioPickerStatus"
      >
        <ArchivePicker
          v-model:value="formState.file_audio"
          :supportedTypes="['.mp3']"
          :maxMBSize="3"
        />
      </a-form-item>
    </DisabledContainer>
    <AudioPreview
      v-if="formState.file_audio"
      :node-src="node?.file_audio_url"
      :file="formState.file_audio"
    />

    <!-- <a-divider class="divider" /> -->

    <!-- <a-form-item label="Nombre de la marcación numérica (Opcional)" name="name_numerical_dialing">
      <a-input
        v-model:value="formState.name_numerical_dialing"
        placeholder="Escribir nombre de la marcación"
      />
      <p class="info">Te facilitará su visualización en el reporte del IVR</p>
    </a-form-item>

    <a-form-item name="time_waiting">
      <template #label>
        <span>Segundos a esperar en esta acción</span>
        <a-form-item-rest>
          <a-switch v-model:checked="formState.wait_answer" size="small" />
        </a-form-item-rest>
      </template>

      <a-select
:getPopupContainer="triggerNode => triggerNode.parentNode"        v-model:value="formState.time_waiting"
        :disabled="!formState.wait_answer"
        placeholder="5"
      >
        <a-select-option v-for="item in timeWaitingList" :key="item" :value="item">
          {{ item }}
        </a-select-option>
      </a-select>

       <a-input-number
        v-model:value="formState.time_waiting"
        :disabled="!formState.wait_answer"
        class="input"
        placeholder="5"
        min="0"
        :precision="0"
      /> 
      <p class="info">Se recomienda brindar un mínimo de 5 segundos al contacto</p>
    </a-form-item> -->
    <!-- <p>Si supera el tiempo de espera, se procederá a finalizar la llamada</p> -->
  </a-form>
</template>

<script setup lang="ts">
import { reactive, ref, computed } from "vue";
import { FormInstance } from "ant-design-vue";

import { CreateNodeBody, Node } from "@/@types/ivr";

import ArchivePicker from "@/app/shared/components/molecules/ArchivePicker.vue";
import AudioPreview from "@/app/ivr/bot/components/buttons/AudioPreview.vue";
import DisabledContainer from "@/app/shared/components/molecules/DisabledContainer.vue";

const props = defineProps<{
  node?: Node;
  parentNode?: Node;
  disabled?: boolean;
}>();

const formRef = ref<FormInstance>();
const formState = reactive<Partial<CreateNodeBody>>({
  file_audio: props.node?.file_audio,
  name_numerical_dialing: props.node?.name_numerical_dialing,
  wait_answer: props.node?.wait_answer,
  time_waiting: props.node?.time_waiting,
});

const timeWaitingList: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

const validateAudioPickerStatus = computed(() => (!formState.file_audio ? "error" : ""));

defineExpose({ formState, formRef });
</script>

<style scoped lang="sass">
@import '../../../../styles/common.sass'

p
  margin: 0
  color: $gray-8

.audio-preview
  width: 100%
  height: 32px
  margin-top: 10px

.divider
  margin: 0
  margin-bottom: 24px
  background-color: $gray-4

.info
  color: $text-secondary
  // color: $gray-7

:deep(.ant-form-item-label)
  width: 100%

:deep(label[for="form_item_time_waiting"])
  width: 100%
  display: flex
  justify-content: space-between

.input
  width: 100%
</style>
